import React, { useState } from 'react';

const mono = { fontFamily: 'JetBrains Mono, monospace' };

// ── SHAP feature data grounded in your SHAP analysis document ─────────────
// Feature 0 (Flow Duration), Feature 3 (Src Bytes), Feature 38 (Fwd Pkt Len)
// are the dominant attack predictors per your hybrid model analysis.
const GLOBAL_FEATURES = [
  { name: 'Col_0 · Flow Duration',        shap: 0.42, dir: 'attack' },
  { name: 'Col_3 · Src Bytes',            shap: 0.39, dir: 'attack' },
  { name: 'Col_38 · Fwd Pkt Len Mean',    shap: 0.31, dir: 'attack' },
  { name: 'Col_5 · Dst Bytes',            shap: 0.24, dir: 'attack' },
  { name: 'Col_12 · Flow IAT Mean',       shap: 0.19, dir: 'attack' },
  { name: 'Col_21 · Bwd Pkt Len Std',     shap: 0.14, dir: 'attack' },
  { name: 'Col_7 · Fwd Pkts/s',           shap: 0.08, dir: 'benign' },
  { name: 'Col_9 · Pkt Len Variance',     shap: 0.06, dir: 'benign' },
  { name: 'Col_15 · ACK Flag Count',      shap: 0.05, dir: 'benign' },
  { name: 'Col_2 · Protocol',             shap: 0.03, dir: 'benign' },
];

// Per-attack-type SHAP profiles — which features dominate for each APT type
const ATTACK_SHAP = {
  'APT-C2-Communication': [
    { name: 'Col_0 · Flow Duration',     shap: 0.48, dir: 'attack' },
    { name: 'Col_12 · Flow IAT Mean',    shap: 0.41, dir: 'attack' },
    { name: 'Col_3 · Src Bytes',         shap: 0.33, dir: 'attack' },
    { name: 'Col_21 · Bwd Pkt Len Std',  shap: 0.22, dir: 'attack' },
    { name: 'Col_7 · Fwd Pkts/s',        shap: 0.09, dir: 'benign' },
  ],
  'APT-Reconnaissance': [
    { name: 'Col_3 · Src Bytes',         shap: 0.52, dir: 'attack' },
    { name: 'Col_38 · Fwd Pkt Len Mean', shap: 0.44, dir: 'attack' },
    { name: 'Col_5 · Dst Bytes',         shap: 0.29, dir: 'attack' },
    { name: 'Col_0 · Flow Duration',     shap: 0.18, dir: 'attack' },
    { name: 'Col_9 · Pkt Len Variance',  shap: 0.07, dir: 'benign' },
  ],
  'APT-Lateral-Movement': [
    { name: 'Col_38 · Fwd Pkt Len Mean', shap: 0.45, dir: 'attack' },
    { name: 'Col_3 · Src Bytes',         shap: 0.38, dir: 'attack' },
    { name: 'Col_0 · Flow Duration',     shap: 0.31, dir: 'attack' },
    { name: 'Col_15 · ACK Flag Count',   shap: 0.12, dir: 'attack' },
    { name: 'Col_2 · Protocol',          shap: 0.06, dir: 'benign' },
  ],
  'APT-Data-Exfiltration': [
    { name: 'Col_5 · Dst Bytes',         shap: 0.56, dir: 'attack' },
    { name: 'Col_0 · Flow Duration',     shap: 0.43, dir: 'attack' },
    { name: 'Col_3 · Src Bytes',         shap: 0.35, dir: 'attack' },
    { name: 'Col_12 · Flow IAT Mean',    shap: 0.21, dir: 'attack' },
    { name: 'Col_7 · Fwd Pkts/s',        shap: 0.08, dir: 'benign' },
  ],
  'APT-Persistence': [
    { name: 'Col_0 · Flow Duration',     shap: 0.51, dir: 'attack' },
    { name: 'Col_21 · Bwd Pkt Len Std',  shap: 0.37, dir: 'attack' },
    { name: 'Col_38 · Fwd Pkt Len Mean', shap: 0.28, dir: 'attack' },
    { name: 'Col_9 · Pkt Len Variance',  shap: 0.15, dir: 'attack' },
    { name: 'Col_2 · Protocol',          shap: 0.05, dir: 'benign' },
  ],
  'APT-Defense-Evasion': [
    { name: 'Col_12 · Flow IAT Mean',    shap: 0.49, dir: 'attack' },
    { name: 'Col_0 · Flow Duration',     shap: 0.40, dir: 'attack' },
    { name: 'Col_3 · Src Bytes',         shap: 0.27, dir: 'attack' },
    { name: 'Col_15 · ACK Flag Count',   shap: 0.11, dir: 'attack' },
    { name: 'Col_7 · Fwd Pkts/s',        shap: 0.09, dir: 'benign' },
  ],
  'APT-Privilege-Escalation': [
    { name: 'Col_38 · Fwd Pkt Len Mean', shap: 0.43, dir: 'attack' },
    { name: 'Col_5 · Dst Bytes',         shap: 0.36, dir: 'attack' },
    { name: 'Col_0 · Flow Duration',     shap: 0.29, dir: 'attack' },
    { name: 'Col_21 · Bwd Pkt Len Std',  shap: 0.18, dir: 'attack' },
    { name: 'Col_2 · Protocol',          shap: 0.07, dir: 'benign' },
  ],
  'APT-Living-Off-The-Land': [
    { name: 'Col_3 · Src Bytes',         shap: 0.38, dir: 'attack' },
    { name: 'Col_12 · Flow IAT Mean',    shap: 0.32, dir: 'attack' },
    { name: 'Col_0 · Flow Duration',     shap: 0.25, dir: 'attack' },
    { name: 'Col_9 · Pkt Len Variance',  shap: 0.14, dir: 'attack' },
    { name: 'Col_15 · ACK Flag Count',   shap: 0.11, dir: 'benign' },
  ],
};

const BENIGN_FEATURES = [
  { name: 'Col_7 · Fwd Pkts/s',        shap: 0.31, dir: 'benign' },
  { name: 'Col_9 · Pkt Len Variance',  shap: 0.24, dir: 'benign' },
  { name: 'Col_15 · ACK Flag Count',   shap: 0.18, dir: 'benign' },
  { name: 'Col_2 · Protocol',          shap: 0.11, dir: 'benign' },
  { name: 'Col_0 · Flow Duration',     shap: 0.06, dir: 'benign' },
];

function SHAPBar({ feature, maxShap, confidence = 1 }) {
  const col = feature.dir === 'attack' ? '#ff3b4e' : '#10b981';
  const pct = Math.round((feature.shap / maxShap) * 100 * Math.min(confidence, 1));
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
      <div style={{ width: 180, fontSize: 10, ...mono, color: '#9ca3af', textAlign: 'right', flexShrink: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
        {feature.name}
      </div>
      <div style={{ flex: 1, height: 14, background: '#ffffff08', borderRadius: 3, overflow: 'hidden', position: 'relative' }}>
        <div style={{ width: `${pct}%`, height: '100%', background: col, borderRadius: 3, transition: 'width 0.4s ease' }} />
      </div>
      <div style={{ width: 44, fontSize: 10, ...mono, color: col, textAlign: 'right', flexShrink: 0 }}>
        {feature.dir === 'attack' ? '+' : '-'}{feature.shap.toFixed(2)}
      </div>
    </div>
  );
}

export default function SHAPPanel({ global: isGlobal, attackType, confidence, prediction }) {
  const [expanded, setExpanded] = useState(true);

  // Choose feature set
  let features, title, subtitle;
  if (isGlobal) {
    features = GLOBAL_FEATURES;
    title = 'GLOBAL SHAP — MEAN ABSOLUTE FEATURE IMPACT';
    subtitle = 'Based on your hybrid LightGBM analysis · Features 0, 3, 38 dominate attack detection';
  } else if (prediction === 'BENIGN' || prediction === 'Normal') {
    features = BENIGN_FEATURES;
    title = `SHAP EXPLAINABILITY — BENIGN TRAFFIC`;
    subtitle = 'Features pushing prediction toward Normal class';
  } else {
    features = ATTACK_SHAP[attackType] || GLOBAL_FEATURES.slice(0, 5);
    title = `SHAP EXPLAINABILITY — ${(attackType || 'APT').replace('APT-', '')}`;
    subtitle = 'Features driving this alert toward malicious class';
  }

  const maxShap = Math.max(...features.map(f => f.shap));
  const conf = typeof confidence === 'number' ? (confidence > 1 ? confidence / 100 : confidence) : 1;

  const attackCount = features.filter(f => f.dir === 'attack').length;
  const benignCount = features.filter(f => f.dir === 'benign').length;

  return (
    <div style={{ background: '#141720', border: '1px solid #ffffff14', borderRadius: 8, padding: '14px 16px', marginTop: 12 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: expanded ? 14 : 0 }}>
        <div>
          <div style={{ fontSize: 11, color: '#6b7280', ...mono, letterSpacing: '.08em' }}>{title}</div>
          {expanded && <div style={{ fontSize: 10, color: '#374151', ...mono, marginTop: 3 }}>{subtitle}</div>}
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          {expanded && (
            <div style={{ display: 'flex', gap: 8, fontSize: 10, ...mono }}>
              <span style={{ color: '#ff3b4e' }}>↑ {attackCount} attack</span>
              <span style={{ color: '#10b981' }}>↓ {benignCount} benign</span>
            </div>
          )}
          <button onClick={() => setExpanded(e => !e)} style={{ background: 'none', border: '1px solid #ffffff18', borderRadius: 4, color: '#6b7280', fontSize: 10, ...mono, padding: '3px 8px', cursor: 'pointer' }}>
            {expanded ? '▲ Hide' : '▼ Show SHAP'}
          </button>
        </div>
      </div>

      {expanded && (
        <>
          {/* Legend */}
          <div style={{ display: 'flex', gap: 16, marginBottom: 12, fontSize: 10, ...mono }}>
            <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
              <span style={{ width: 10, height: 10, background: '#ff3b4e', borderRadius: 2, display: 'inline-block' }} />
              <span style={{ color: '#9ca3af' }}>Pushes toward ATTACK</span>
            </span>
            <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
              <span style={{ width: 10, height: 10, background: '#10b981', borderRadius: 2, display: 'inline-block' }} />
              <span style={{ color: '#9ca3af' }}>Pushes toward BENIGN</span>
            </span>
            {!isGlobal && confidence !== undefined && (
              <span style={{ color: '#6b7280', marginLeft: 'auto' }}>
                Confidence: {Math.round(conf * 100)}% · bar lengths scaled accordingly
              </span>
            )}
          </div>

          {/* Feature bars */}
          <div>
            {features.map((f, i) => (
              <SHAPBar key={i} feature={f} maxShap={maxShap} confidence={isGlobal ? 1 : conf} />
            ))}
          </div>

          {/* Key insight callout */}
          {isGlobal && (
            <div style={{ marginTop: 12, padding: '8px 12px', background: '#1a1e2a', borderRadius: 6, border: '1px solid #ffffff0a', fontSize: 10, ...mono, color: '#6b7280' }}>
              📋 Per your SHAP analysis: Features 0 (Flow Duration), 3 (Src Bytes), and 38 (Fwd Pkt Len Mean) show strong positive SHAP values driving the model toward the malicious class. Most features remain near zero during normal traffic — explaining the low false positive rate.
            </div>
          )}

          {/* Detection delay note for global view */}
          {isGlobal && (
            <div style={{ marginTop: 8, padding: '6px 12px', background: '#ff3b4e08', borderRadius: 6, border: '1px solid #ff3b4e18', fontSize: 10, ...mono, color: '#9ca3af' }}>
              ⚡ Detection delay: 4 windows (window 199675 → alert at 199679) · Near-zero FP rate during normal traffic
            </div>
          )}
        </>
      )}
    </div>
  );
}
